module.exports = __webpack_public_path__ + "img/paso_4.b3019cea.png";